const getGenders = [
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
  { value: 'ND', label: 'Não declarar' },
];

export default getGenders;
